import {
  MappedClass,
  MappedProperty,
  MappedPropertyArray,
  MappedPropertyClass,
  MappedPropertyDate,
} from '@h5s/util-object';
import { DateTime } from 'luxon';
import { Customer, CustomerData } from '../../profile-registry/entities';
import { PurchasedStayToCustomer, Room } from '../../reservation/entities';

import { ResourceValidationResult } from '../../shared/entities';

@MappedClass()
export class PsCustomer {
  @MappedProperty({ toDto: 'einvoicingCode' })
  EInvoicingCode: string | null;

  /** the difference between the current date and the entered date must be >= 7 */
  @MappedPropertyDate()
  birthDate: DateTime | null = null;

  @MappedProperty()
  birthDistrict: string | null;

  @MappedProperty()
  birthPlace: string | null;

  @MappedProperty()
  birthPlaceId: number | null;

  @MappedProperty()
  birthState: string | null;

  @MappedProperty()
  birthStateId: number | null;

  @MappedPropertyDate()
  checkIn: DateTime;

  @MappedPropertyDate()
  checkOut: DateTime;

  @MappedProperty()
  creditCardId: number | null;

  @MappedProperty()
  customerCode: string | null;

  @MappedProperty(undefined, true)
  customerDataId: number | null;

  @MappedPropertyClass(() => CustomerData)
  customerData: CustomerData;

  @MappedPropertyDate()
  documentDeadlineDate: DateTime | null;

  @MappedProperty()
  documentNumber: string | null;

  @MappedPropertyDate()
  documentReleaseDate: DateTime | null;

  @MappedProperty()
  documentReleaser: string | null;

  @MappedProperty()
  documentReleaserCityId: number | null;

  @MappedProperty()
  documentReleaserState: boolean;

  @MappedProperty()
  documentReleaserStateId: number | null;

  @MappedProperty()
  documentType: string | null;

  @MappedProperty()
  fiscalCode: string | null;

  @MappedProperty()
  id: number;

  @MappedProperty()
  leader: boolean;

  @MappedProperty()
  lotteryCode: string | null;

  @MappedProperty()
  middleName: string | null;

  @MappedProperty()
  multidbDocumentTypeId: number | null;

  @MappedProperty()
  name: string | null;

  @MappedProperty()
  nationality: string | null;

  @MappedProperty()
  nationalityId: number | null;

  @MappedProperty()
  numberOfNights: number;

  @MappedProperty()
  password: string | null;

  @MappedProperty()
  pec: string | null;

  @MappedProperty()
  publicSecurityStatus: string;

  @MappedPropertyClass(() => PurchasedStayToCustomer)
  purchasedStayToCustomer: PurchasedStayToCustomer;

  @MappedPropertyArray(() => Customer)
  relatives: Customer[];

  @MappedProperty()
  room: string;

  @MappedPropertyClass(() => Room)
  roomObj: Room;

  @MappedProperty()
  sex: boolean;

  @MappedProperty()
  state: string | null;

  @MappedProperty()
  stateId: number | null;

  @MappedProperty()
  surname: string;

  @MappedPropertyArray(() => ResourceValidationResult)
  validationResults: ResourceValidationResult<Customer>[];

  @MappedProperty()
  vatCountryCode: string | null;

  @MappedProperty()
  vatNumber: string | null;

  constructor(init?: Partial<PsCustomer>) {
    Object.assign(this, init);
  }

  public getDisplayName(): string {
    return [this.surname, this.name].join(' ');
  }

  /**
   * Verifica che il PsCustomer si valido.
   * E' valido se validationResults non ha elementi e quindi non ci sono errori
   */
  public get isValid(): boolean {
    return this.validationResults.length === 0;
  }
}
